<template>
    <div class="">
        <div class="navigation-group">
            <router-link :to="{name:'GoalDetailPageMainTasks', query: $route.query}" v-show="isMember" replace>
                <vue-folder-button :active="$route.name==='GoalDetailPageMainTasks'" :text="tasksLabel"
                                   icon-class="fa-tasks"></vue-folder-button>
            </router-link>
            <router-link :to="{name:'GoalDetailPageMainTimeline', query: $route.query}" v-show="isMember" replace>
                <vue-folder-button :active="$route.name==='GoalDetailPageMainTimeline'" text="Timeline"
                                   icon-class="fa-clock-o"></vue-folder-button>
            </router-link>

            <router-link :to="{name:'GoalDetailPageMainAbout', query: $route.query}" replace>
                <vue-folder-button :active="$route.name==='GoalDetailPageMainAbout'" text="About"
                                   icon-class="fa-info"></vue-folder-button>
            </router-link>
            <router-link :to="{name:'GoalDetailPageMainAttachments', query: $route.query}" replace
                         v-show="isMember&&(!isShowMoreNeeded||showMorePressed)">
                <vue-folder-button :active="$route.name==='GoalDetailPageMainAttachments'" text="Attachments"
                                   icon-class="fa-file-text"></vue-folder-button>
            </router-link>

            <router-link :to="{name:'GoalDetailPageMainMembers', query: $route.query}" replace
                         v-show="isMember&&(!isShowMoreNeeded||showMorePressed)">
                <vue-folder-button :active="$route.name==='GoalDetailPageMainMembers'" text="Members"
                                   icon-class="fa-users"></vue-folder-button>
            </router-link>

            <vue-folder-button text="" icon-class="fa-ellipsis-h" v-show="isShowMoreNeeded"
                               color="color-header"
                               inner-color="#9c9c9c"
                               @click.native="showMore"></vue-folder-button>
        </div>
        <div class="actions-group">
            <vue-folder-button
                    v-show="$route.name==='GoalDetailPageMainTasks'"
                    v-if="filterAllowed"
                    :color="filterButtonColor"
                    :text="filterTasksLabel"
                    :max-width="100"
                    icon-class="fa-filter"
                    @click.native="editFilter"
                    :no-text-on-mobile="true"
            ></vue-folder-button>
            <vue-folder-button text="Full Screen" icon-class="fa-expand-arrows-alt" v-if="isFullScreenPossible"
                               @click.native="runFullscreen" :no-text-on-mobile="true"></vue-folder-button>

            <vue-folder-button :text="editModeButtonLabel" :icon-class="editModeButtonClass" v-if="isEditModePossible"
                               @click.native="toggleEditMode" :no-text-on-mobile="true"></vue-folder-button>

            <vue-folder-button text="Make Me Admin" icon-class="fa-user-secret" v-if="iCanMakeMeAdmin"
                               @click.native="makeMeAdmin" :no-text-on-mobile="true"></vue-folder-button>

            <vue-folder-button text="Back" color="blue" icon-class="fa-reply" @click.native="goBack"
                               :no-text-on-mobile="true"></vue-folder-button>
        </div>
    </div>
</template>

<script>
    import {goalHeaderBus, GOAL_HEADER_BUS_ACTIONS} from './goalHeaderBus.js';
    import {customTermFilter} from "../../../../../../vue/filters/CustomTerm";

    export default {
        name: "GoalDetailPageHeaderButtonsPanel",
        props: {
            filterAllowed: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showMorePressed: false
            };
        },
        computed: {
            assigneesInFilter() {
                return this.$store.state.goalDetailPageStore.assigneesInFilter;
            },
            filterButtonColor() {
                if (this.assigneesInFilter.length) {
                    return 'grass-green';
                }
            },
            filterTasksLabel() {
                return `Filter ${this.$customTerm('Tasks')}`;
            },
            tasksLabel() {
                return this.$customTerm('Tasks');
            },
            isFullScreenPossible() {
                return this.$route.name === 'GoalDetailPageMainTimeline';
            },
            iCanMakeMeAdmin() {
                return this.$store.getters['goalDetailPageStore/iCanMakeMeAdmin'];
            },
            isMember() {
                return this.$store.state.goalDetailPageStore.isMember;
            },
            isAdmin() {
                return this.$store.state.goalDetailPageStore.isAdmin;
            },
            isEditModePossible() {
                return this.$store.getters['goalDetailPageStore/isEditModePossible'];
            },
            isShowMoreNeeded() {
                return this.isMember && !this.showMorePressed;
            },
            activeUrl() {
                return this.$store.state.goalDetailPageStore.activeUrl;
            },
            editModeButtonClass() {
                if (this.$store.state.goalDetailPageStore.editMode) {
                    return 'fa-eye';
                } else {
                    return 'fa-pencil';
                }
            },
            editModeButtonLabel() {
                if (this.$store.state.goalDetailPageStore.editMode) {
                    return `View ${customTermFilter('Goal')}`;
                } else {
                    return `Edit ${customTermFilter('Goal')}`;
                }
            }
        },
        methods: {
            makeMeAdmin() {
                this.$store.dispatch('goalDetailPageStore/make_me_admin');
            },
            goBack() {
                goalHeaderBus.$emit(GOAL_HEADER_BUS_ACTIONS.GO_BACK);
            },
            goToPage(url) {
                goalHeaderBus.$emit(GOAL_HEADER_BUS_ACTIONS.GO_TO_PAGE, url);
            },
            toggleEditMode() {
                this.$store.commit('goalDetailPageStore/set_edit_mode', {
                    value: !this.$store.state.goalDetailPageStore.editMode,
                    emitEvent: true
                });
            },
            showMore() {
                this.showMorePressed = true;
            },
            runFullscreen() {
                goalHeaderBus.$emit(GOAL_HEADER_BUS_ACTIONS.RUN_FULLSCREEN_ON_TIMELINE);
            },
            editFilter() {
                this.$emit('filterClicked');
            }
        },
        mounted() {
            if (this.isShowMoreNeeded && ['GoalDetailPageMainMembers', 'GoalDetailPageMainAttachments', 'GoalDetailPageMainAbout'].includes(this.$route.name)) {
                this.showMore();
            }
        }

    };
</script>

<style scoped lang="scss">
  .navigation-group {
    float: left;
  }

  .actions-group {
    float: right;
  }
</style>